var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3323_25892)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0247 30.8238C17.928 31.0036 17.805 31.2098 17.654 31.3933C17.5149 31.5623 17.2723 31.8118 16.9096 31.9321C16.4719 32.0773 16.0352 31.9795 15.6944 31.7323C15.4041 31.5217 15.2034 31.2214 15.0555 30.9397C14.1565 29.2263 13.0788 27.6203 11.934 26.0132C11.5644 25.4943 11.1846 24.971 10.8017 24.4436C10.0132 23.3572 9.21178 22.2531 8.45966 21.1324C6.78263 18.6311 5.18285 15.8646 5.01557 12.4604C4.71834 6.37604 8.71301 1.22466 14.6269 0.168385C20.2199 -0.830518 25.6573 2.68103 27.4524 8.28139C27.8352 9.4657 28.0155 10.6852 27.999 11.6659C28.0281 15.2536 26.73 18.0621 25.047 20.5845M20.5936 25.0615C20.8462 24.718 21.0999 24.3752 21.3535 24.0325C22.3296 22.7138 23.3058 21.395 24.2147 20.0302C25.8375 17.5983 27.029 14.9824 26.9989 11.6612C27.0151 10.8003 26.8552 9.68456 26.5005 8.58772C24.8453 3.42197 19.8611 0.249389 14.8027 1.15281C9.40128 2.11755 5.74081 6.81155 6.01436 12.4113C6.16736 15.5249 7.62784 18.096 9.29001 20.5751C10.0322 21.681 10.8143 22.7585 11.5964 23.8359C13.1498 25.9759 14.7028 28.1153 15.941 30.4749C16.4139 31.376 16.8103 30.9703 17.1441 30.3499C18.1456 28.4865 19.3464 26.7599 20.5936 25.0615Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3323_25892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9989 11.6616C27.029 14.9827 25.8375 17.5986 24.2147 20.0306C23.0695 21.7501 21.8177 23.3965 20.5936 25.0619C19.3464 26.7602 18.1456 28.4868 17.1441 30.3503C16.8103 30.9706 16.4139 31.3763 15.941 30.4753C14.0794 26.9277 11.5062 23.8777 9.29 20.5754C7.62784 18.0963 6.16736 15.5253 6.01436 12.4117C5.74081 6.81188 9.40128 2.11789 14.8027 1.15314C19.8611 0.249723 24.8453 3.4223 26.5005 8.58805C26.8552 9.68489 27.0151 10.8006 26.9989 11.6616Z",
    fill: "#C4C4C4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3323_25892)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3323_25892",
    x: 3.00003,
    y: -0.000976562,
    width: 27,
    height: 36.001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3323_25892"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3323_25892",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3323_25892",
    x: 4,
    y: 1,
    width: 25,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3323_25892"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3323_25892",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3323_25892",
    x: 7,
    y: 4,
    width: 19,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3323_25892"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3323_25892",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/disabled.005519e24a52655a1026a86992306d79.svg";
export { ForwardRef as ReactComponent };